// extracted by mini-css-extract-plugin
export default {"BtnsGroup":"modalFilter_BtnsGroup__r9pNe"};